import React from 'react';
import { Header, Segment, Responsive } from 'semantic-ui-react';
import axios from 'axios';
import SemesterInfo from '../../Admin/CreateStudyProgram/SemesterInfo';
import Tab from 'semantic-ui-react/dist/es/modules/Tab/Tab';
import { toast, ToastContainer } from 'react-toastify';
import SemesterCourses from '../../Admin/CreateStudyProgram/SemesterCourses';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudentServiceSPImplSemesters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesters: [],
            lookupSemesters: [],
            panes: [],
            edit: false,
            addSemesterMode: false,
            activeIndex: 0

        };
        this.getSemesters = this.getSemesters.bind(this);
        this.getPanes = this.getPanes.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        this.getSemesters();

        axios.get('study-program-semesters')
            .then(res => {
                this.setState({
                    lookupSemesters: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch semesters');
            });
    }

    getSemesters() {
        let id = this.props.location.state ? this.props.location.state.implementation.studyProgram.id : JSON.parse(localStorage.getItem('implementation')).studyProgram.id;

        axios.get(`study-programs/semesters/${id}`)
            .then(res => {
                this.setState({ semesters: res.data.sort((b, a) => b.studyProgramSemester.number - a.studyProgramSemester.number) });
                this.getPanes(res.data);
            })
            .catch(err => {
                console.log('Failed to fetch semesters');
            });
    }


    getPanes(semesters) {
        let panes = [];
        semesters.map(el => {
            panes.push({
                menuItem: `${el.studyProgramSemester.name}`,
                render: () => (<Tab.Pane clearing as={Responsive}>
                    <h3>Osnovne informacije o semestru</h3>
                    <SemesterInfo
                        semester={el}
                        getSemesters={() => {
                            toast('Uspješno ste obrisali semestar sa implementacije studijskog programa.');
                            this.setState({ activeIndex: 0 });
                            this.getSemesters();
                        }}
                        studentService
                    />
                    <br /><br /><br /><br />
                    <SemesterCourses
                        semesterId={el.id}
                        sPsemesterId={el.studyProgramSemester.id}
                        semesterNumber={el.studyProgramSemester.number}
                        newSPId={this.props.location.state ? this.props.location.state.implementation.id : JSON.parse(localStorage.getItem('implementation')).id}
                        getSemesters={this.getSemesters}
                        semesters={this.state.semesters}
                        studentService
                    />
                </Tab.Pane>)
            });
        });

        this.setState({ panes });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
        localStorage.setItem('changeSemester', true);
    }


    render() {
        let implementation = this.props.location.state && this.props.location.state.implementation ? this.props.location.state.implementation : JSON.parse(localStorage.getItem('implementation'));


        return (
            <div>
                <Header as="h1">Semestri</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                {localStorage.getItem('studyProgramBasicName')} - {implementation.studyProgram.name}
                            </Header.Content>
                            <Header.Subheader>{implementation.studyProgram.description ? implementation.studyProgram.description : localStorage.getItem('studyProgramDescription') !== 'null' ? localStorage.getItem('studyProgramDescription') : ''}</Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={this.state.panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/StudentServiceSPImplSemesters.js